const routesNames = {
  EVENT_VIEW_SETTINGS: 'event-view-settings',
  EVENT_VIEW_USER_FIELDS_EDITOR: 'event-view-user-fields-editor',
  EVENT_VIEW_BANNER: 'event-view-banner',
  EVENT_VIEW_PRIVACY_POLICY: 'event-view-privacy-policy',
  EVENT_VIEW_CHECK_IN: 'event-view-check-in',
  EVENT_VIEW_MAILING: 'event-view-mailing',
  EVENT_VIEW_USERS: 'event-view-users',
  EVENT_VIEW_SURVEY_SETTINGS: 'event-view-edit-survey',
  EVENT_VIEW_IMPORT_USERS: 'event-view-import-users',
  EVENT_VIEW_SURVEY: 'event-view-survey',
  EVENT_VIEW_SURVEY_EDIT_QUESTIONS: 'edit-questions',
  EVENT_VIEW_SURVEY_QUESTION_TYPES_REORDER: 'reorder-question-types',
  EVENT_VIEW_MARKETING_EMAILS: 'event-view-marketing-emails',
  EVENT_VIEW_SCU: 'event-view-scu',
  CHECK_IN: 'check-in',
  REGISTER: 'register',
};

export default routesNames;
